import { useQuery } from '@tanstack/react-query'

import { fetchTenantBranding, TENANT_BRANDING_QUERY_KEY } from '@/api/branding'

export function useTenantBranding() {
  return useQuery({
    queryKey: TENANT_BRANDING_QUERY_KEY,
    queryFn: fetchTenantBranding,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  })
}

export function tenantDisplayName(
  branding: { website_name?: string | null; tenant_name?: string | null } | undefined,
): string {
  const name = branding?.website_name?.trim() || branding?.tenant_name?.trim()
  return name || 'Mağaza'
}
